module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "acuerdo-detail"
  }, [_c('md-sidenav', {
    ref: "rightSidenav",
    staticClass: "md-right",
    on: {
      "close": function($event) {
        _vm.close()
      }
    }
  }, [_c('md-toolbar', [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h4', {
    staticClass: "md-title"
  }, [_vm._v("Acuerdo de Objetivos")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button close",
    nativeOn: {
      "click": function($event) {
        _vm.closeRightSidenav()
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1)]), _vm._v(" "), _c('md-subheader', [(_vm.acuerdo) ? _c('div', [_vm._v("Dueño " + _vm._s(_vm.acuerdo.ownerObject.displayName))]) : _vm._e()]), _vm._v(" "), _c('md-subheader', [(_vm.acuerdo) ? _c('div', [_vm._v("Editor " + _vm._s(_vm.acuerdo.editorObject.displayName))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.objetivos), function(obj, index) {
    return _c('md-card', {
      key: index,
      staticClass: "card-obj-detail",
      attrs: {
        "md-flex-xsmall": "100",
        "md-flex-small": "50",
        "md-flex-medium": "50",
        "md-align": "center"
      }
    }, [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v("Objetivo " + _vm._s(index + 1))])]), _vm._v(" "), _c('md-card-content', [_c('div', [_vm._v("\n                      " + _vm._s(obj.descripcion) + "\n                  ")]), _vm._v(" "), _c('div', [_vm._v("\n                      " + _vm._s(obj.notas) + "\n                  ")]), _vm._v(" "), _c('md-checkbox', {
      attrs: {
        "disabled": _vm.acuerdo && (_vm.currentUser.email !== _vm.acuerdo.editorObject.email || _vm.acuerdo.finalizado !== undefined)
      },
      on: {
        "change": function($event) {
          _vm.change(obj)
        }
      },
      model: {
        value: (obj.cumplido),
        callback: function($$v) {
          obj.cumplido = $$v
        },
        expression: "obj.cumplido"
      }
    }, [_vm._v("Cumplido?")]), _vm._v(" "), (obj.cumplido) ? _c('md-input-container', [_c('label', [_vm._v("Fecha")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "disabled": _vm.currentUser.email !== _vm.acuerdo.editorObject.email || _vm.acuerdo.finalizado !== undefined,
        "type": "date"
      },
      model: {
        value: (obj.fecha),
        callback: function($$v) {
          obj.fecha = $$v
        },
        expression: "obj.fecha"
      }
    })], 1) : _vm._e()], 1)], 1)
  })), _vm._v(" "), (_vm.acuerdo.editorObject && _vm.acuerdo.editorObject.email === _vm.currentUser.email && !_vm.acuerdo.finalizado) ? _c('div', {
    staticClass: "container-buttons"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.guardar()
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.finalizar()
      }
    }
  }, [_vm._v("Finalizar")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b40d4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AcuerdoDetail.vue
// module id = 379
// module chunks = 1